<template>
  <div class="long-container">
    <second-level>
      <div class="title">
        <h3 class="chinese">相关视频</h3>
        <div class="inner">
          <h3 class="english">Relevant Video</h3>
          <p class="line"></p>
        </div>
      </div>
    </second-level>
    <div class="inner">
      <video-player></video-player>
      <blue-circle></blue-circle>
    </div>
  </div>
</template>

<script>
import SecondLevel from "../../SecondLevel";
import VideoPlayer from "./VideoPlayer";
import BlueCircle from "./BlueCircle";
export default {
  name: "Index",
  components: {
    SecondLevel,
    VideoPlayer,
    BlueCircle
  }
};
</script>

<style lang="scss" scoped>
.long-container {
  width: 75%;
  margin: 0 auto;
  /*display: flex;*/
  .inner {
    display: flex;
  }
}
</style>
